import React, { useState, useEffect, useMemo } from "react"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import API from "../../api"
import {
  Button,
  Col,
  Form,
  Input,
  Label,
  Row,
  Card,
  CardBody,
  Container,
  Spinner,
} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import { withTranslation } from "react-i18next"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Select from "react-select";

const EditDiplome = props => {
  const [nom, setNom] = useState("")
  const [loading, setLoading] = useState(false)
  const [cycle, setCycle] = useState("")
  const [selectCycle, setSelectCycle] = useState("")

  useEffect(async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    const resCycle = await API.get("cycle/select").then(resCycle => {
      setCycle(resCycle.data.Cycle)
    })
    const res = await API.post("diplome/get_by_id", { id }).then(res => {
        setNom(res.data.Diplome.name)
        setSelectCycle(res.data.Diplome.cycle)
        setLoading(true)
    })
  }, [])

  const edit = async () => {
    var url = window.location.href
    var array = url.split("=")
    var id = array[1]
    if (nom != "" && selectCycle!="") {
      const res = await API.post("diplome/update", {
        id: id,
        name: nom,
        cycle_id:selectCycle.value
      }).then(res => {
        props.history.push("/Diplome")
      })
    } else {
      toast.error("⛔ Cycle et nom sont obligatoires", {
        containerId: "A",
      })
    }
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Card>
              <CardBody>
                {loading ? (
                  <AvForm>
                    <Form>
                      <Row>
                          <Col lg="6">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1">Cycle</Label>
                          <Select
                              options={cycle}
                              isSearchable={true}
                              value={selectCycle}
                              onChange={e => setSelectCycle(e)}
                          />
                        </div>
                          </Col>
                        <Col lg="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              {props.t("Nom")} :
                            </Label>
                            <Input
                              lg="3"
                              className="form-control glyphicon glyphicon-star"
                              placeholder={props.t("Nom")}
                              type="text"
                              value={nom}
                              onChange={e => setNom(e.target.value)}
                            />
                          </div>
                        </Col>

                      </Row>
                    </Form>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      {" "}
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                          className="text-center mt-4"
                        >
                          <Button
                            type="button"
                            color="warning"
                            className="btn btn-warning  mb-2 me-2"
                            onClick={() => props.history.push("/Statut")}
                          >
                            {props.t("Annuler")}
                          </Button>
                        </div>
                      </Col>
                      <Col lg="6">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-start",
                          }}
                          className="text-center mt-4"
                        >
                          <button
                            type="button"
                            className="btn btn-primary "
                            onClick={edit}
                          >
                            {props.t("Confirmer")}
                          </button>
                        </div>
                      </Col>
                    </div>
                  </AvForm>
                ) : (
                  <div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      {" "}
                      <Spinner type="grow" className="ms-6" color="primary" />
                    </div>
                    <h4
                      style={{ textAlign: "center", marginTop: "2%" }}
                      className="ms-6"
                    >
                      {" "}
                      {"Chargement"} ...{" "}
                    </h4>
                  </div>
                )}
              </CardBody>
            </Card>
          </Row>
          <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}
export default withRouter(withTranslation()(EditDiplome))
EditDiplome.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
